// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"17e7bad3","592":"74deaa71","957":"904a4bcd"}[chunkId] + ".chunk.js";
};